export const Footer = {
    newsletter: {
        header: "uiText.footer.newsletter.header",
        success: "uiText.footer.newsletter.success",
        description: "uiText.footer.newsletter.description",
        successDescription: "uiText.footer.newsletter.successDescription",
        emailInputPlaceholder: "uiText.footer.newsletter.emailInputPlaceholder",
        checkboxText: "uiText.footer.newsletter.checkboxText",
        emailLabel: "uiText.footer.newsletter.emailLabel",
        nameLabel: "uiText.footer.newsletter.nameLabel",
        discountDisclaimer: "uiText.footer.newsletter.discountDisclaimer",
    },
};
